import { ComponentProps } from 'react'
import { styled } from 'stitches.config'
import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { Footer } from 'components/Footer'
import { Loader } from 'features/components/Loader'
import { useFetchProductVariants } from 'features/ECommerce/api/queries/useFetchProductVariants'
import { useAddToCart } from 'features/ECommerce/hooks/useAddToCart'
import { RecipeDetailBenefits } from 'features/Recipes/FreezeDriedRecipeDetail/components/RecipeDetailBenefits'
import {
  IngredientType,
  RecipeDetailIngredients,
} from 'features/Recipes/FreezeDriedRecipeDetail/components/RecipeDetailIngredients/RecipeDetailIngredients'
import { TranslationKeys } from 'locales/translationKeys'
import venisonBoxBenefits from '../../../../../../public/assets/recipes/frozen/venison-box-benefits.webp'
import { Hero } from './components/Hero'

const VenisonBoxRoot = styled('div', {})

type VenisonBoxOwnProps = ComponentProps<typeof VenisonBoxRoot>
export type VenisonBoxProps = VenisonBoxOwnProps & {}

const benefits: TranslationKeys[] = [
  'recipes:frozen-v2.VENISON.benefits.list.0',
  'recipes:frozen-v2.VENISON.benefits.list.1',
  'recipes:frozen-v2.VENISON.benefits.list.2',
  'recipes:frozen-v2.VENISON.benefits.list.3',
  'recipes:frozen-v2.VENISON.benefits.list.4',
]

const ingredients: IngredientType[] = [
  {
    label: 'recipes:individual.ingredients.venison.label',
    description: 'recipes:individual.ingredients.venison.info',
  },
  {
    label: 'recipes:individual.ingredients.beef-heart.label',
    description: 'recipes:individual.ingredients.beef-heart.info',
  },
  {
    label: 'recipes:individual.ingredients.beef-liver.label',
    description: 'recipes:individual.ingredients.beef-liver.info',
  },
  {
    label: 'recipes:individual.ingredients.beef-kidney.label',
    description: 'recipes:individual.ingredients.beef-kidney.info',
  },
  {
    label: 'recipes:individual.ingredients.beef-bone.label',
    description: 'recipes:individual.ingredients.beef-bone.info',
  },
  {
    label: 'recipes:individual.ingredients.vitamin.label',
    description: 'recipes:individual.ingredients.vitamin.info',
  },
]

export const VenisonBox = (_props: VenisonBoxProps) => {
  const header = <Header />
  const addToCart = useAddToCart()

  const { data: response, status } = useFetchProductVariants({
    page: 1,
    limit: 10,
    textSearch: 'Venison Box',
  })

  if (status === 'loading' || status === 'idle' || status === 'error') return <Loader />

  return (
    <VenisonBoxRoot>
      <Layout hideCTA header={header}>
        <Hero onAdd={addToCart} products={response.productVariants} />
        <RecipeDetailBenefits
          title="products:fivePound.benefits"
          list={benefits}
          imageSrc={venisonBoxBenefits}
          imageAlt="products-v2:venison-box.benefits.image"
        />
        <RecipeDetailIngredients
          title="products-v2:venison-box.ingredients.title"
          rows={ingredients}
          condensed
        />
        <Footer />
      </Layout>
    </VenisonBoxRoot>
  )
}

VenisonBox.displayName = 'VenisonBox'
